import * as styledComponents from 'styled-components';
import * as theme from 'ui/theme';

const withProps = <SProps, TProps extends object = theme.IThemeInterface, U extends HTMLElement = HTMLElement>(
  styledFunction: styledComponents.ThemedStyledFunction<any, any>, // tslint:disable-line no-any
): styledComponents.ThemedStyledFunction<SProps & React.HTMLProps<U>, TProps> => {
  return styledFunction;
};

const {
  default: styled,
  css,
  injectGlobal,
  keyframes,
  ThemeProvider,
} = styledComponents as styledComponents.ThemedStyledComponentsModule<theme.IThemeInterface>;

export { css, injectGlobal, keyframes, ThemeProvider, withProps };
export default styled;
